// ===============================================================================
// CreateGroup.js - Create New Group Page for WOW
// ===============================================================================
// Location: /var/www/wow/frontend/src/CreateGroup.js
// Form to create a new expense group
// ===============================================================================

import React, { useState } from "react";
import { groupsAPI } from "./api";
import "./CreateGroup.css";

function CreateGroup({ onBack, onGroupCreated }) {
  // ===============================================================================
  // State
  // ===============================================================================
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [currency, setCurrency] = useState("EUR");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // ===============================================================================
  // Currencies
  // ===============================================================================
  const currencies = [
    { code: "EUR", name: "Euro (€)" },
    { code: "USD", name: "US Dollar ($)" },
    { code: "GBP", name: "British Pound (£)" },
    { code: "CHF", name: "Swiss Franc" },
    { code: "SEK", name: "Swedish Krona" },
    { code: "NOK", name: "Norwegian Krone" },
    { code: "DKK", name: "Danish Krone" },
    { code: "PLN", name: "Polish Złoty" },
    { code: "CZK", name: "Czech Koruna" },
    { code: "HUF", name: "Hungarian Forint" },
    { code: "RON", name: "Romanian Leu" },
    { code: "BGN", name: "Bulgarian Lev" },
    { code: "TRY", name: "Turkish Lira" },
    { code: "CAD", name: "Canadian Dollar" },
    { code: "AUD", name: "Australian Dollar" },
    { code: "JPY", name: "Japanese Yen" },
    { code: "CNY", name: "Chinese Yuan" },
    { code: "INR", name: "Indian Rupee" },
  ];

  // ===============================================================================
  // Submit Handler
  // ===============================================================================
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!name.trim()) {
      setError("Group name is required");
      return;
    }
    
    setLoading(true);
    setError("");
    
    try {
      const res = await groupsAPI.create(name.trim(), description.trim(), currency);
      if (res.data?.ok) {
        console.log("✅ Group created:", res.data.group);
        onGroupCreated(res.data.group);
      } else {
        setError("Failed to create group");
      }
    } catch (err) {
      console.error("Create group error:", err);
      setError(err?.response?.data?.detail || "Failed to create group");
    }
    
    setLoading(false);
  };

  // ===============================================================================
  // Render
  // ===============================================================================
  return (
    <div className="create-group-page">

      <div className="create-group-card">
        <div className="card-icon">🎉</div>
        <h2>Start a New Group</h2>
        <p>Create a group to track shared expenses with friends, roommates, or travel buddies</p>

        <form onSubmit={handleSubmit} className="create-form">
          <div className="form-group">
            <label htmlFor="name">Group Name *</label>
            <input
              id="name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g., Rome Trip 2025, Apartment Expenses"
              disabled={loading}
              maxLength={100}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="description">Description (optional)</label>
            <textarea
              id="description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Add a short description for your group"
              disabled={loading}
              rows={3}
            />
          </div>

          <div className="form-group">
            <label htmlFor="currency">Currency</label>
            <select
              id="currency"
              value={currency}
              onChange={(e) => setCurrency(e.target.value)}
              disabled={loading}
            >
              {currencies.map((c) => (
                <option key={c.code} value={c.code}>
                  {c.code} - {c.name}
                </option>
              ))}
            </select>
          </div>

          {error && <div className="form-error">{error}</div>}

          <button type="submit" className="submit-button" disabled={loading}>
            {loading ? "Creating..." : "Create Group"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default CreateGroup;

